export default "__VITE_ASSET__CLp5CURl__"